import { Box, Button, List, ListItem, Stack, Typography } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import icongrayCross from "../../public/assets/images/icon-sm-cross.svg";
import styles from "../../styles/pages/user/managerdashboard/manager-dashborad-assignaccount.module.scss";
import SelectMonth from "../SelectMonth/SelectMonth";
import SelectDay from "../SelectDay/SelectDay";
import SelectYear from "../SelectYear/SelectYear";
import { useState } from "react";
import { NotificationFilterDates } from "../../data/consts";

export default function ManagerassignFilter(props) {
  const [currentDateFilter, setCurrentDateFilter] = useState("today");

  const [startDate, setStartDate] = useState({
    day: "",
    month: "",
    year: "",
  });
  const [startDate2, setStartDate2] = useState({
    day: "",
    month: "",
    year: "",
  });

  //   child data
  const handleChildData = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate({ ...startDate, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
  };

  const handleChildData2 = (anchorEl) => {
    if (anchorEl.day) {
      setStartDate2({ ...startDate2, day: anchorEl.day });
    } else if (anchorEl.month) {
      setStartDate2({ ...startDate2, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate2({ ...startDate2, year: anchorEl.year });
    }
  };

  //   child data

  //   current filter
  const filtereditorList2 = (type, day) => {
    // let date = new Date(2020, 4, 12);
    const date = new Date();
    let dd = date.getDate();
    let mm = date.getMonth();
    let yy = date.getFullYear();
    let getThisWeek = new Date();
    function getMonday(d) {
      var day = d.getDay();
      var diff = d.getDate() - day + (day == 0 ? -6 : 1); // adjust when day is sunday
      getThisWeek = new Date(d.setDate(diff));
    }

    if (day == "today") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "yesterday") {
      let datex = date;
      datex.setDate(dd - 1);
      let currentDate =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth =
        datex.getMonth() > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let published_at_from =
        currentYear + "-" + currentMonth + "-" + currentDate;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_week") {
      getMonday(date);
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth = mm > 9 ? mm : "0" + (mm + 1);
      let currentYear = Number(yy);
      let currentDate2 =
        getThisWeek.getDate() > 9
          ? getThisWeek.getDate()
          : "0" + getThisWeek.getDate();
      let currentMonth2 =
        getThisWeek.getMonth() > 9
          ? getThisWeek.getMonth() + 1
          : "0" + (getThisWeek.getMonth() + 1);
      let currentYear2 = getThisWeek.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_7_days") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let datex = date;
      datex.setDate(date.getDate() - 7);
      let currentDate2 =
        datex.getDate() > 9 ? datex.getDate() : "0" + datex.getDate();
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_month") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_month") {
      let datex = date;
      datex.setDate(date.getDate() - dd);
      let days = datex.getDate() + 1;
      let currentDate = datex.getDate();
      let currentMonth =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_6_months") {
      let datex = date;
      datex.setMonth(date.getMonth() - 5);
      let days = datex.getDate();
      let currentDate = dd > 9 ? dd : "0" + dd;
      let currentMonth = mm + 1 > 9 ? mm + 1 : "0" + (mm + 1);
      let currentYear = yy;
      let currentDate2 = "0" + (days - days + 1);
      let currentMonth2 =
        datex.getMonth() + 1 > 9
          ? datex.getMonth() + 1
          : "0" + (datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "this_year") {
      let currentDate = Number(dd) > 9 ? Number(dd) : "0" + Number(dd);
      let currentMonth =
        Number(mm) > 9 ? Number(mm) + 1 : "0" + (Number(mm) + 1);
      let currentYear = Number(yy);
      let currentDate2 = "0" + (Number(dd) - Number(dd) + 1);
      let currentMonth2 = "0" + (Number(mm) - Number(mm) + 1);
      let currentYear2 = Number(yy);
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    } else if (day == "last_year") {
      let datex = date;
      datex.setFullYear(yy - 1);
      let currentDate = 31;
      let currentMonth = datex.getMonth() * 0 + 12;
      let currentYear = datex.getFullYear();
      let currentDate2 = "0" + (datex.getDate() - datex.getDate() + 1);
      let currentMonth2 = "0" + (datex.getMonth() - datex.getMonth() + 1);
      let currentYear2 = datex.getFullYear();
      let published_at_from =
        currentYear2 + "-" + currentMonth2 + "-" + currentDate2;
      let published_at_to =
        currentYear + "-" + currentMonth + "-" + currentDate;
      props.getDataFromChild({
        startDate: published_at_from,
        endDate: published_at_to,
        type: day,
      });
    }
    setCurrentDateFilter(day);
  };
  //   current filter

  //   date
  let tarikh = startDate.year + "-" + startDate.month + "-" + startDate.day;

  let tarikh2 = startDate2.year + "-" + startDate2.month + "-" + startDate2.day;
  //   date

  //   item

  // item
  return (
    <Box className={styles.filterNotification}>
      <List className={styles.selectMonthList} disablePadding>
        {NotificationFilterDates?.map((item, index) => (
          <ListItem
            key={index}
            className={
              item.value === currentDateFilter ? `${styles.filterToday}` : ""
            }
            disablePadding
          >
            <Link
              href="javascript:void(0)"
              onClick={() => filtereditorList2("filter", item.value)}
            >
              {item.name}
            </Link>
            {item.value === currentDateFilter ? (
              <Button className={styles.viewall_btn}>
                <img src={icongrayCross} width={10} height={10} alt="icon" />
                view all
              </Button>
            ) : (
              ""
            )}
          </ListItem>
        ))}
        {/* <ListItem disablePadding>
          <Link to="#">
            Today{" "}
            <Button>
              <img src={icongrayCross} alt="" /> view all
            </Button>
          </Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">Yesterday</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">This week</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">Last 7 days</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">This month</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">Last month</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">Last 6 months</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">This year</Link>
        </ListItem>
        <ListItem disablePadding>
          <Link to="#">Last year</Link>
        </ListItem> */}
      </List>
      <Box className={`${styles.dateRange}`}>
        <Typography variant="overline">Start date</Typography>
        <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
          <SelectMonth sendDataToParent={handleChildData} />
          <SelectDay sendDataToParent={handleChildData} />
          <SelectYear sendDataToParent={handleChildData} />
        </Stack>
      </Box>
      <Box className={`${styles.dateRange}`}>
        <Typography variant="overline">End date</Typography>
        <Stack direction="row" flexWrap="wrap" className={styles.monthStacks}>
          <SelectMonth sendDataToParent={handleChildData2} />
          <SelectDay sendDataToParent={handleChildData2} />
          <SelectYear sendDataToParent={handleChildData2} />
        </Stack>
      </Box>
      <Box className={`${styles.dateConfirm}`}>
        <Button
          onClick={() =>
            props.getDataFromChild({
              startDate: tarikh,
              endDate: tarikh2,
              type: "custom date",
            })
          }
        >
          <span>Confirm</span> date range
        </Button>
      </Box>
    </Box>
  );
}
